export default {
  // Navigation
  nav_home: 'الرئيسية',
  nav_dashboard: 'لوحة القيادة',
  nav_orders: 'الطلبات',
  nav_wallet: 'المحفظة',
  nav_analytics: 'التحليلات',
  nav_referral: 'الإحالة',
  nav_account: 'الحساب',
  nav_notifications: 'الإشعارات',
  nav_logout: 'تسجيل الخروج',
  nav_login: 'تسجيل الدخول',
  nav_signup: 'إنضم إلينا',
  nav_deposit_requests: 'طلبات الإيداع',
  nav_withdraw_requests: 'طلبات السحب',
  nav_support_ticket: 'تذكرة الدعم',
  nav_system_logs: 'سجلات النظام',
  nav_announcements: 'الإعلانات',
  nav_activity_logs: 'سجلات النشاط',
  nav_settings: 'الإعدادات',
  nav_section_main: 'الرئيسي',
  nav_user_active: 'نشط الآن',
  nav_more: 'المزيد',
  nav_logout_confirm: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
  nav_language: 'اللغة',

  // Dashboard
  dashboard_welcome: 'مرحباً بعودتك',
  dashboard_total_earnings: 'إجمالي الأرباح',
  dashboard_pending_orders: 'الطلبات المعلقة',
  dashboard_completed_orders: 'الطلبات المكتملة',
  dashboard_commission_rate: 'نسبة العموله',
  dashboard_quick_actions: 'إجراءات سريعة',
  dashboard_recent_orders: 'الطلبات الأخيرة',
  dashboard_recent_activity: 'النشاط الأخير',
  dashboard_wallet_balance: 'رصيد المحفظة',
  dashboard_deposit: 'إيداع',
  dashboard_withdraw: 'سحب',
  dashboard_view_all: 'عرض الكل',
  greeting_morning: 'صباح الخير',
  greeting_afternoon: 'طاب مساؤك',
  greeting_evening: 'مساء الخير',
  dashboard_greeting_desc: 'تتبع أرباحك، وأكمل الطلبات، وقم بإدارة حسابك في مكان واحد. رحلة نجاحك تستمر هنا!',

  // Dashboard Stats
  stats_available_balance: 'الرصيد المتاح',
  stats_total_withdrawn: 'إجمالي المسحوبات',
  stats_total_deposit: 'إجمالي الإيداعات',
  stats_pending_orders: 'الطلبات المعلقة',
  stats_orders_suffix: ' طلبات',
  stats_task_earnings: 'أرباح المهام',
  stats_lifetime_earning: 'أرباح مدى الحياة',

  // Orders
  orders_title: 'طلباتي',
  orders_all: 'كل الطلبات',
  orders_step_4: 'تقديم الترويج',
  orders_step_5: 'SEO Indexing',
  orders_step_6: 'Boosting Visibility',
  orders_step_7: 'الوضع اللانهائي وتأكيد',
  orders_btn_optimize: 'تحسين الطلب',
  orders_btn_claim_commission: 'سحب العمولات',
  orders_btn_task_completed: 'اكتملت المهمة',
  orders_price_label: 'سعر الطلب',
  orders_commission_rate_label: 'نسبة العمولة',
  orders_pending: 'قيد الانتظار',
  orders_completed: 'مكتمل',
  orders_cancelled: 'ملغى',
  orders_order_id: 'رقم الطلب',
  orders_platform: 'المنصة',
  orders_amount: 'المبلغ',
  orders_commission: 'العمولة',
  orders_status: 'الحالة',
  orders_date: 'التاريخ',
  orders_actions: 'الإجراءات',
  orders_no_orders: 'لم يتم العثور على طلبات',

  // Wallet
  wallet_title: 'محفظتي',
  wallet_available_balance: 'الرصيد المتاح',
  wallet_pending_balance: 'الرصيد المعلق',
  wallet_total_withdrawn: 'إجمالي المسحوبات',
  wallet_deposit_now: 'إيداع الآن',
  wallet_withdraw_now: 'سحب الآن',
  wallet_transaction_history: 'سجل المعاملات',
  wallet_deposit_history: "سجل الإيداع",
  wallet_withdrawal_history: 'سجل السحب',
  wallet_deposit_desc: "أضف المال إلى محفظتك باستخدام طرق الدفع المتاحة.",
  wallet_no_deposits: "لا توجد عمليات إيداع.",
  wallet_withdraw_history: "سجل السحب",
  wallet_withdraw_desc: "اسحب المال من محفظتك.",
  wallet_no_withdrawals: "لا توجد عمليات سحب.",
  wallet_no_withdrawals_desc: "لم تقم بأي عمليات سحب حتى الآن.",
  withdrawal_restricted_title: 'Withdrawal Restricted',
  withdrawal_restricted_message: 'Withdrawals are currently unavailable for your account. Please contact customer support for more information.',

  // Analytics
  analytics_title: 'التحليلات',
  analytics_earnings_overview: 'نظرة عامة على الأرباح',
  analytics_platform_breakdown: 'توزيع المنصات',
  analytics_performance_metrics: 'مقاييس الأداء',
  analytics_top_products: 'أفضل المنتجات',
  analytics_this_month: 'هذا الشهر',
  analytics_last_month: 'الشهر الماضي',
  analytics_total_revenue: 'إجمالي الإيرادات',
  analytics_avg_order_value: 'متوسط قيمة الطلب',

  // Referral
  referral_title: 'برنامج الإحالة',
  referral_your_code: 'رمز الإحالة الخاص بك',
  referral_copy_code: 'نسخ الرمز',
  referral_share_link: 'مشاركة الرابط',
  referral_total_referrals: 'إجمالي الإحالات',
  referral_active_referrals: 'الإحالات النشطة',
  referral_referral_earnings: 'أرباح الإحالة',
  referral_invite_friends: 'دعوة الأصدقاء',

  // Account
  security_row_title: 'إعدادات الأمان',
  security_login_pw: 'كلمة مرور تسجيل الدخول',
  security_login_pw_desc: 'تغيير كلمة مرور تسجيل الدخول الخاصة بحسابك',
  security_change_btn: 'تغيير',
  security_set_withdrawal_pw_title: 'تعيين كلمة مرور السحب',
  security_set_withdrawal_pw_desc: 'إنشاء رمز PIN منفصل لتفويض عمليات السحب',
  security_set_withdrawal_pw_btn: 'تعيين رمز PIN',
  security_change_withdrawal_pw_title: 'تغيير كلمة مرور السحب',
  security_change_withdrawal_pw_desc: 'تحديث رمز PIN الحالي للسحب الخاص بك',
  security_change_withdrawal_pw_btn: 'تغيير',
  security_modal_set_withdrawal_title: 'تعيين كلمة مرور السحب',
  security_modal_set_withdrawal_subtitle: 'سيُطلب هذا الرمز PIN في كل مرة تقوم فيها بعملية سحب.',
  security_modal_change_withdrawal_title: 'تغيير كلمة مرور السحب',
  security_field_current_pin: 'رمز PIN الحالي للسحب',
  security_field_new_pin: 'رمز PIN الجديد للسحب',
  security_field_new_pin_6: 'رمز PIN الجديد للسحب (6 أرقام)',
  security_field_confirm_pin: 'تأكيد رمز PIN',
  security_field_confirm_new_pin: 'تأكيد رمز PIN الجديد',
  security_fill_all: 'يرجى ملء جميع الحقول.',
  security_match_err: 'كلمات المرور غير متطابقة.',
  security_pin_6_err: 'يجب أن يتكون رمز PIN من 6 أرقام بالضبط.',
  security_pin_digit_err: 'يجب أن يحتوي رمز PIN على أرقام فقط.',

  // Settings
  settings_page_title: 'الإعدادات',
  settings_page_desc: 'إدارة الأمان والخصوصية والتفضيلات الخاصة بك',
  settings_kyc_label: 'تحقق KYC',
  settings_kyc_desc: 'التحقق من الهوية',
  settings_security_label: 'الأمان',
  settings_security_desc: 'إدارة كلمة المرور',
  settings_language_label: 'اللغة',
  settings_language_desc: 'التفضيلات الإقليمية',

  // Support
  support_btn_send: 'إرسال الرد',
  support_edit_message: 'تعديل الرسالة',
  support_delete_message: 'حذف الرسالة',
  support_delete_confirm: 'هل أنت متأكد أنك تريد حذف هذه الرسالة؟',
  support_message_updated: 'تم تحديث الرسالة بنجاح',
  support_message_deleted: 'تم حذف الرسالة بنجاح',
  support_err_already_read: 'لا يمكن تعديل الرسالة بعد أن تمت رؤيتها.',

  account_two_factor: 'المصادقة الثنائية',
  account_save_changes: 'حفظ التغييرات',
  account_cancel: 'إلغاء',

  // Auth & Common
  auth_email: 'البريد الإلكتروني',
  auth_password: 'كلمة المرور',
  auth_confirm_password: 'تأكيد كلمة المرور',
  auth_password_min_chars: '8 أحرف على الأقل',
  auth_password_uppercase: 'حرف كبير واحد (A-Z)',
  auth_password_lowercase: 'حرف صغير واحد (a-z)',
  auth_password_number: 'رقم واحد (0-9)',
  auth_password_special: 'حرف خاص واحد (!@#$%^& إلخ.)',
  auth_forgot_password: 'هل نسيت كلمة المرور؟',
  auth_remember_me: 'تذكرني',
  auth_login_button: 'تسجيل الدخول',
  auth_signup_button: 'إنشاء حساب',
  auth_already_have_account: 'لديك حساب بالفعل؟',
  auth_dont_have_account: "ليس لديك حساب؟",
  auth_reset_password: 'إعادة تعيين كلمة المرور',
  auth_verify_email: 'التحقق من البريد الإلكتروني',
  auth_live_platform: 'المنصة المباشرة',
  auth_security_verification: 'التحقق الأمني',
  auth_captcha_refresh: 'تحديث',
  auth_captcha_placeholder: 'النتيجة',
  auth_captcha_error: 'المجموع غير صحيح، يرجى المحاولة مرة أخرى',
  auth_branding_title: 'حوّل العروض الترويجية إلى',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'دخل حقيقي',
  auth_branding_desc: 'انضم إلى آلاف المروجين الذين يكسبون عمولات يومية من أفضل العلامات التجارية للتجارة الإلكترونية في جميع أنحاء العالم.',
  auth_sign_in_to_account: 'سجل الدخول إلى حسابك في {{system_name}}',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'أدخل كلمة المرور الخاصة بك',
  auth_signing_in: 'جاري تسجيل الدخول...',
  auth_free_to_join: 'الانضمام مجاني',
  auth_signup_branding_title: 'ابدأ الكسب',
  auth_signup_branding_highlight: 'من اليوم الأول',
  auth_signup_branding_desc: 'لا حاجة للخبرة. سجل في دقيقتين وابدأ في إكمال المهام لأفضل العلامات التجارية للتجارة الإلكترونية.',
  auth_how_it_works: 'كيف يعمل',
  auth_signup_desc: 'انضم إلى {{system_name}} وابدأ في كسب العمولات اليوم - إنه مجاني!',
  auth_step_1: 'أنشئ حسابك المجاني',
  auth_step_2: 'تصفح وقبول المهام',
  auth_step_3: 'أكمل واكسب العمولات',
  auth_signup_step_1_title: 'إنشاء حساب',
  auth_signup_step_1_desc: 'ابدأ رحلتك',
  auth_signup_step_2_title: 'إكمال المهام',
  auth_signup_step_2_desc: 'اكسب عمولات يومية',
  auth_signup_step_3_title: 'سحب الأموال',
  auth_signup_step_3_desc: 'دفعات سريعة وآمنة',
  auth_benefit_1_title: 'آمن وموثوق',
  auth_benefit_1_desc: 'أمان بمستوى البنوك لأرباحك',
  auth_benefit_2_title: 'دفعات فورية',
  auth_benefit_2_desc: 'اسحب أرباحك خلال 24 ساعة',
  auth_benefit_3_title: 'مجتمع عالمي',
  auth_benefit_3_desc: 'انضم إلى أكثر من 12,000 مروج نشط',
  auth_benefit_4_title: 'دعم 24/7',
  auth_benefit_4_desc: 'احصل على المساعدة وقتما تحتاجها',

  common_loading: 'جاري التحميل...',
  common_save: 'حفظ',
  common_cancel: 'إلغاء',
  common_delete: 'حذف',
  common_edit: 'تعديل',
  common_view: 'عرض',
  common_search: 'بحث',
  common_filter: 'فلترة',
  common_export: 'تصدير',
  common_import: 'استيراد',
  common_submit: 'إرسال',
  common_close: 'إغلاق',
  common_confirm: 'تأكيد',
  common_success: 'نجاح',
  common_error: 'خطأ',
  common_warning: 'تحذير',
  common_announcement: 'إعلان',

  val_full_name_required: 'الاسم الكامل مطلوب',
  val_email_required: 'البريد الإلكتروني مطلوب',
  val_password_required: 'كلمة المرور مطلوبة',
  val_password_min: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  val_passwords_dont_match: 'كلمات المرور غير متطابقة',
  val_agree_terms: 'يجب عليك الموافقة على الشروط',
  val_conn_error: 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',

  // Homepage
  home_hero_title: 'اكسب عمولة من أفضل منصات التجارة الإلكترونية',
  home_hero_subtitle: 'انضم إلى آلاف المستخدمين الذين يحققون عمولات يومية من وولمارت وعلي بابا وعلي إكسبريس',
  home_get_started: 'ابدأ الآن',
  home_learn_more: 'تعرف على المزيد',
  home_how_it_works: 'كيف يعمل',
  home_features: 'الميزات',
  home_why_choose_us: 'لماذا تختارنا',
  home_features_title: 'ميزات قوية',
  home_features_subtitle: 'كل ما تحتاجه للبدء في الكسب عبر الإنترنت. صُمم مع مراعاة نجاحك.',
  home_commission_tiers: 'مستويات العمولة',
  home_testimonials: 'ماذا يقول مستخدمونا',
  home_faq: 'الأسئلة الشائعة',
  home_cta_title: 'هل أنت مستعد لبدء الكسب؟',
  home_cta_subtitle: 'انضم إلى مجتمعنا اليوم وابدأ في كسب العمولات',
  home_trusted_partner: 'منصات شركاء موثوقة',
  home_secure_platform: 'منصة آمنة',
  home_instant_payouts: 'دفعات فورية',
  home_active_users: 'المستخدمون النشطون',
  home_total_paid_out: 'إجمالي المبالغ المدفوعة',
  home_user_rating: 'تقييم المستخدمين',
  home_countries: 'الدول',

  // Feature Section
  feature_1_title: 'دفعات فورية',
  feature_1_desc: 'احصل على أرباحك فوراً بعد إكمال الطلب. اسحب في أي وقت دون تأخير.',
  feature_1_detail_1: 'قيد سريع للعمولة',
  feature_1_detail_2: 'خيارات سحب متعددة',
  feature_1_detail_3: 'لا يوجد حد أدنى للسحب',
  feature_2_title: 'منصة آمنة',
  feature_2_desc: 'تشفير بمستوى البنوك يحمي بياناتك وأرباحك. موثوق به من قبل آلاف المستخدمين في جميع أنحاء العالم.',
  feature_2_detail_1: 'تشفير SSL مفعل',
  feature_2_detail_2: 'المصادقة الثنائية',
  feature_2_detail_3: 'تدقيق أمني دوري',
  feature_2_detail_4: 'خصوصية البيانات مضمونة',
  feature_3_title: 'ساعات مرنة',
  feature_3_desc: 'اعمل وقتما تشاء ومن أي مكان. أكمل الطلبات بالسرعة التي تناسبك دون جدول زمني محدد.',
  feature_3_detail_1: 'لا توجد ساعات عمل ثابتة',
  feature_3_detail_2: 'اعمل من أي مكان',
  feature_3_detail_3: 'اختر الوتيرة الخاصة بك',
  feature_3_detail_4: 'متاح في عطلات نهاية الأسبوع',
  feature_4_title: 'أرباح تصاعدية',
  feature_4_desc: 'افتح مستويات عمولة أعلى مع إكمال المزيد من الطلبات. ضاعف دخلك مع كل ترقية للمستوى.',
  feature_4_detail_1: 'مستويات عمولة متدرجة',
  feature_4_detail_2: 'ترقيات تلقائية للمستوى',
  feature_4_detail_3: 'مكافآت الأداء',
  feature_5_title: 'منصة عالمية',
  feature_5_desc: 'اعمل مع علامات تجارية عالمية من أي مكان في العالم. دعم العملات المتعددة متضمن.',
  feature_5_detail_1: 'متوفر عالمياً',
  feature_5_detail_2: 'دعم عملات متعددة',
  feature_5_detail_3: 'طرق دفع محلية',
  feature_6_title: 'دعم 24/7',
  feature_6_desc: 'فريق الدعم المخصص لدينا جاهز دائماً للمساعدة. احصل على المساعدة عبر الدردشة المباشرة أو البريد الإلكتروني أو الهاتف.',
  feature_6_detail_1: 'الدردشة المباشرة متاحة',
  feature_6_detail_2: 'دعم البريد الإلكتروني 24/7',
  feature_6_detail_3: 'المساعدة عبر الهاتف',
  feature_6_detail_4: 'أسئلة شائعة شاملة',
  feature_7_title: 'برنامج الإحالة',
  feature_7_desc: 'اربح دخلاً إضافياً عن طريق دعوة الأصدقاء. احصل على عمولات مدى الحياة من أرباح إحالاتك.',
  feature_7_detail_1: 'أرباح إحالة مدى الحياة',
  feature_7_detail_2: 'إحالات غير محدودة',
  feature_7_detail_3: 'أدوات مشاركة سهلة',
  feature_7_detail_4: 'حوافز إضافية',
  feature_8_title: 'عملات متعددة',
  feature_8_desc: 'دعم العملات الرئيسية وطرق الدفع. اختر ما يناسبك بشكل أفضل.',
  feature_8_detail_1: 'دعم USD، EUR، GBP',
  feature_8_detail_2: 'التحويل البنكي متاح',
  feature_8_detail_3: 'تكامل المحفظة الإلكترونية',
  feature_8_detail_4: 'خيارات الكريبتو قريباً',
  feature_9_title: 'إشعارات فورية',
  feature_9_desc: 'ابقَ على اطلاع دائم بتنبيهات في الوقت الفعلي للطلبات الجديدة والأرباح وأنشطة الحساب.',
  feature_9_detail_1: 'إشعارات الدفع',
  feature_9_detail_2: 'تنبيهات البريد الإلكتروني',
  feature_9_detail_3: 'تحديثات SMS',
  feature_9_detail_4: 'رسائل داخل التطبيق',

  // Home Page Additional Sections
  home_how_it_works_badge: 'عملية بسيطة',
  home_how_it_works_title: 'كيف يعمل',
  home_how_it_works_subtitle: 'ابدأ الكسب في 4 خطوات بسيطة. لا حاجة للخبرة، فقط اتبع العملية وشاهد أرباحك تنمو.',
  home_cta_ready_title: 'هل أنت مستعد لبدء رحلتك؟',
  home_cta_ready_desc: 'انضم إلى آلاف المستخدمين الذين يكسبون يومياً بالفعل. عمولتك الأولى تفصلك عنها دقائق معدودة!',
  home_cta_avg_time: 'متوسط الوقت لأول كسب:',
  home_cta_15_mins: '15 دقيقة',
  home_cta_new_users: 'مستخدمون جدد اليوم:',

  // How It Works Steps
  step_1_title: 'إنشاء حساب',
  step_1_desc: 'أنشئ حسابك في أقل من دقيقتين.',
  step_1_detail_1: 'قدم المعلومات الأساسية',
  step_1_detail_2: 'تحقق من بريدك الإلكتروني',
  step_1_detail_3: 'أمن حسابك',
  step_1_detail_4: 'وصول فوري للوحة التحكم',

  step_2_title: 'البحث عن المهام',
  step_2_desc: 'اختر من مهام الترويج المتاحة.',
  step_2_detail_1: 'تصفية حسب المنصة',
  step_2_detail_2: 'عرض نسب العمولة',
  step_2_detail_3: 'قبول مهام متعددة',
  step_2_detail_4: 'تحديثات للمهام في الوقت الفعلي',

  step_3_title: 'إكمال المهام',
  step_3_desc: 'أكمل العروض الترويجية وفقاً للتعليمات.',
  step_3_detail_1: 'خطوات سهلة المتابعة',
  step_3_detail_2: 'تقديم سريع للمهام',
  step_3_detail_3: 'تحقق تلقائي',
  step_3_detail_4: 'واجهة متوافقة مع الجوال',

  step_4_title: 'كسب وسحب',
  step_4_desc: 'احصل على أموالك مقابل كل مهمة مكتملة.',
  step_4_detail_1: 'تتبع الأرباح في الوقت الفعلي',
  step_4_detail_2: 'حد أدنى منخفض للسحب',
  step_4_detail_3: 'طرق دفع متعددة',
  step_4_detail_4: 'دعم السحب 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'ابق في الحلقة',
  footer_stay_loop_desc: 'احصل على آخر التحديثات والنصائح والعروض الحصرية مباشرة إلى بريدك الإلكتروني.',
  footer_subscribe: 'اشترك',
  footer_subscribe_placeholder: 'أدخل عنوان بريدك الإلكتروني',
  footer_trusted_secure: 'موثوق وآمن:',
  footer_ssl_secured: 'تأمين SSL',
  footer_ssl_secured_desc: 'SSL 256 بت',
  footer_aes_encryption: 'تشفير AES-256',
  footer_aes_encryption_desc: 'بدرجة مصرفية',
  footer_kyc_compliant: 'متوافق مع KYC',
  footer_kyc_compliant_desc: 'تم التحقق منه',
  footer_gdpr_compliant: 'متوافق مع GDPR',
  footer_gdpr_compliant_desc: 'بيانات محمية',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'معتمد',
  footer_platform: 'المنصة',
  footer_support: 'الدعم',
  footer_legal: 'قانوني',
  footer_help_center: 'مركز المساعدة',
  footer_contact_us: 'اتصل بنا',
  footer_payments_label: 'المدفوعات:',
  home_live_activity_title: 'نشاط المنصة المباشر',
  home_recent_activity_title: 'النشاط الأخير',
  home_total_commissions_paid: 'إجمالي العمولات المدفوعة',
  home_active_users_online: 'المستخدمون النشطون عبر الإنترنت',
  home_tasks_completed_today: 'المهام المكتملة اليوم',
  account_security_tips_title: 'توصيات أمنية',
  account_security_tips_desc: 'حسّن حماية حسابك من خلال اتباع هذه الممارسات البسيطة.',
  tip_password_title: 'كلمة مرور قوية',
  tip_password_desc: 'استخدم مزيجًا من الحروف والأرقام والرموز لضمان بقاء حسابك آمنًا.',
  tip_two_factor_title: 'التحقق من الهوية',
  tip_two_factor_desc: 'حافظ على تحديث معلومات الاتصال الخاصة بك لتلقي إشعارات أمنية هامة.',
  tip_logout_title: 'تسجيل الخروج بانتظام',
  tip_logout_desc: 'قم دائمًا بتسجيل الخروج من حسابك عند استخدام أجهزة كمبيوتر عامة أو مشتركة.',
  tip_sharing_title: 'لا تشارك الوصول أبدًا',
  tip_sharing_desc: 'لن يطلب فريق الدعم لدينا كلمة مرورك أبدًا. لا تشارك بيانات اعتمادك مع أي شخص.',

  // طلبات الطلب
  order_requests_title: 'طلبات الطلبات',
  order_requests_desc: 'أرسل طلباً لمهمة جديدة أو طلب مخصص. سيقوم المشرف بالمراجعة وتعيين المهام بناءً على طلبك.',
  order_requests_new_btn: 'طلب جديد',
  order_requests_table_id: 'رقم الطلب',
  order_requests_table_data: 'تفاصيل الطلب',
  order_requests_table_status: 'الحالة',
  order_requests_table_date: 'تاريخ التقديم',
  order_requests_table_actions: 'الإجراءات',
  order_requests_cancel: 'إلغاء',
  order_requests_cancel_confirm: 'هل أنت متأكد أنك تريد إلغاء طلب الطلب هذا؟',
  order_requests_cancel_success: 'تم إلغاء طلب الطلب بنجاح.',
  order_requests_create_success: 'تم تقديم طلب الطلب بنجاح.',
  order_requests_modal_title: 'تقديم طلب جديد',
  order_requests_modal_desc: 'يرجى تقديم معلومات مفصلة عن الطلب الذي ترغب في طلبه.',
  order_requests_field_data: 'بيانات الطلب',
  order_requests_field_placeholder: 'مثال: أريد طلب طلب مخصص للباقة المميزة.',
  order_requests_btn_submit: 'تقديم الطلب',
  order_requests_btn_submitting: 'جاري التقديم...',
  order_requests_empty: 'لم يتم العثور على طلبات.',
  order_requests_status_pending: 'قيد الانتظار',
  order_requests_status_approved: 'تمت الموافقة',
  order_requests_status_rejected: 'مرفوض',
  order_requests_status_cancelled: 'ملغى',
  order_requests_terms_title: 'شروط الطلب الملزمة',
  order_requests_term_1: 'سيتم تخصيص الطلبات الجديدة في غضون 24-48 ساعة من الموافقة.',
  order_requests_term_2: 'بمجرد إصدار الطلبات، لا يمكن إلغاؤها أو إيقافها مؤقتًا أو تعديلها.',
  order_requests_term_3: 'يجب إكمال جميع الطلبات المخصصة قبل السحب.',
  order_requests_term_4: 'قد يؤثر عدم إكمال الطلبات على وضع حسابك.',
  order_requests_term_5: 'هذا الطلب نهائي ولا يمكن الرجوع عنه بعد التقديم.',
  order_requests_policy_title: 'سياسة عدم الإلغاء',
  order_requests_policy_desc: 'بتقديم هذا الطلب، فإنك تقر بأن دفعة الطلبات الجديدة غير قابلة للإلغاء. بمجرد تأكيدها من قبل نظامنا، لن يُسمح بأي إلغاء أو تعديل أو استرداد تحت أي ظرف من الظروف.',
  order_requests_accept_terms: 'لقد قرأت الشروط المذكورة أعلاه وأفهمها تمامًا. أقر بأنه بمجرد تقديم طلب الطلب هذا، لا يمكن إلغاؤه أو تعديله، وأوافق على إكمال جميع الطلبات المخصصة.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'سياسة السحب',
  orders_unlock_req: 'متطلبات فتح السحب',
  orders_unlock_desc: 'أكمل أول دفعة من {{count}} طلبات لفتح السحب بشكل دائم. هذا المطلب لمرة واحدة يضمن نزاهة المنصة ويمنع سوء الاستخدام.',
  orders_daily_limits: 'حدود الطلبات اليومية',
  orders_daily_limit_1: '{{count}} طلبات لكل دفعة — يجب إكمال جميع الطلبات قبل طلب الدفعة التالية',
  orders_daily_limit_2: 'الحد الأقصى {{count}} دفعات يوميًا ({{total}} طلب يوميًا)',
  orders_comm_rates: 'معدلات العمولات',
  orders_comm_rates_desc: 'يتم تحديد المعدلات حسب المنصة ورصيد محفظتك الحالي:',
  orders_payout_timeline: 'الجدول الزمني للصرف',
  orders_payout_desc: 'يتم معالجة السحوبات خلال 24-48 ساعة. قد تستغرق التحويلات البنكية 3-5 أيام عمل. عمليات سحب العملات المشفرة فورية.',
  orders_processing_fee: 'يتم تطبيق رسوم معالجة بنسبة {{fee}}% على جميع السحوبات لتغطية تكاليف المعاملات.',
  orders_tips_title: 'نصائح للنجاح',
  orders_tips_1: 'أكمل الطلبات يوميًا لبناء الزخم وزيادة الأرباح',
  orders_tips_2: 'ابق في الصفحة أثناء المعالجة لضمان الإكمال السليم',
  orders_tips_3: 'تحقق من محفظتك بانتظام لتتبع نمو العمولات',
  orders_tips_4: 'قم بإحالة الأصدقاء لكسب عمولات إضافية على طلباتهم',
  orders_tips_5: 'اتصل بالدعم فورًا إذا واجهت أي مشاكل',
  orders_batch_approx: '{{count}} طلبات/دفعة × بمتوسط ${{avg}} = حوالي ${{total}} لكل دفعة',
  // Deposit Modal
  deposit_modal_title_method: "اختر طريقة الدفع",
  deposit_modal_title_gateway: "اختر محفظة العملات الرقمية",
  deposit_modal_title_plan: "اختر خطة الإيداع",
  deposit_modal_title_details: "تفاصيل الإيداع",
  deposit_modal_step_method: "الطريقة",
  deposit_modal_step_gateway: "المحفظة",
  deposit_modal_step_plan: "الخطة",
  deposit_modal_step_details: "التفاصيل",
  deposit_modal_credit_card: "بطاقة ائتمان / بطاقة خصم",
  deposit_modal_bank_transfer: "تحويل بنكي",
  deposit_modal_ewallet: "محفظة إلكترونية",
  deposit_modal_digital_currency: "عملة رقمية",
  deposit_modal_not_available: "غير متاح في منطقتك",
  deposit_modal_available_recommended: "متاح — موصى به",
  deposit_modal_back_to_method: "العودة إلى طرق الدفع",
  deposit_modal_back_to_gateway: "العودة إلى قائمة المحافظ",
  deposit_modal_back_to_plan: "العودة إلى الخطط",
  deposit_modal_digital_selected: "تم اختيار العملة الرقمية",
  deposit_modal_digital_hint: "اختر محفظتك الرقمية للحصول على العنوان والتعليمات.",
  deposit_modal_loading_wallets: "جارٍ تحميل المحافظ...",
  deposit_modal_no_wallets: "لا توجد محافظ رقمية متاحة.",
  deposit_modal_loading_plans: "جارٍ تحميل الخطط...",
  deposit_modal_no_plans: "لا توجد خطط إيداع متاحة حالياً.",
  deposit_modal_duration: "المدة",
  deposit_modal_amounts_profits: "المبالغ والأرباح",
  deposit_modal_amount_label: "المبلغ",
  deposit_modal_profit_label: "الربح",
  deposit_modal_benefits: "المزايا",
  deposit_modal_continue: "متابعة",
  deposit_modal_transfer_details: "تفاصيل التحويل لـ {{name}}",
  deposit_modal_deposit_amount: "مبلغ الإيداع",
  deposit_modal_amount_fixed: "المبلغ محدد من خطتك المختارة",
  deposit_modal_txn_id: "معرف المعاملة",
  deposit_modal_txn_optional: "(اختياري)",
  deposit_modal_txn_placeholder: "مثال 0x1a2b3c4d...",
  deposit_modal_screenshot: "لقطة شاشة",
  deposit_modal_upload_proof: "رفع إثبات الدفع",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — حد أقصى 5 ميجابايت",
  deposit_modal_comments: "تعليقات",
  deposit_modal_comments_placeholder: "أي معلومات إضافية...",
  deposit_modal_notice: "بعد التقديم، سيتحقق فريقنا من دفعتك ويضيف الرصيد إلى حسابك خلال 5-30 دقيقة.",
  deposit_modal_confirm: "تأكيد الإيداع",
  deposit_modal_submitting: "جارٍ التقديم...",
  deposit_modal_err_fields: "يرجى ملء جميع الحقول المطلوبة",
  deposit_modal_err_submit: "حدث خطأ أثناء التقديم",
  deposit_modal_success: "تم طلب الإيداع بنجاح!",
  deposit_modal_err_plans: "فشل في تحميل خطط الإيداع",
  deposit_modal_err_wallets: "فشل في تحميل طرق الدفع",
  deposit_modal_new_to_crypto: "جديد على العملات الرقمية؟ تعلم كيفية شراء العملة الرقمية",
  deposit_modal_crypto_label: "عملة رقمية",
  orders_insufficient_balance: "رصيد غير كاف",
  orders_balance_gap_msg1: "رصيدك الحالي لا يكفي لإكمال هذا الطلب.",
  orders_balance_gap_msg2_start: "يرجى إضافة",
  orders_balance_gap_msg2_end: "للمتابعة والحصول على عمولتك.",
  orders_btn_add_funds: "إضافة أموال",
  withdrawal_restricted_support: "الاتصال بالدعم",
  deposit_modal_plan_description_hint: "Add the deposit for getting the order and earn the commission from order process",
};
